import type { StaffRole } from "@lafayette/auth";
import { useMemo } from "react";

import { type CapabilityRules, capabilityFlags } from "../access/capabilities";
import { useStaffRoles } from "../access/use-staff-roles";

// What a staff member may do in the itinerary editor. Presentation only: the API decides every request again (a staff member also needs an
// assignment to the customer, or the supervisor role). The roles come from the domain's `capabilityRoles`.

export type TripCapabilities = Readonly<{ read: boolean; manage: boolean }>;

const tripCapabilityRules = {
  read: "trip.read",
  manage: "trip.manage",
} as const satisfies CapabilityRules;

export function tripCapabilitiesForRoles(roles: readonly StaffRole[]): TripCapabilities {
  return capabilityFlags(tripCapabilityRules, roles);
}

export function useTripCapabilities(): Readonly<{
  capabilities: TripCapabilities;
  isLoading: boolean;
}> {
  const { roles, isLoading } = useStaffRoles();
  const capabilities = useMemo(() => tripCapabilitiesForRoles(roles), [roles]);
  return { capabilities, isLoading };
}
